import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import API_BASE_URL from "../config";
import { useNavigate,Link } from "react-router-dom";
import { useDevopstrioAuth } from "../context/DevopstrioAuthContext";
import { FiHome } from "react-icons/fi";     
import "../styles/devopstriologin.css";

export default function DevopstrioLogin() {
  const [email, setEmail] = useState("");
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(120);
  const otpRefs = useRef([]);
  const navigate = useNavigate();
  const { login } = useDevopstrioAuth();
  const otp = otpDigits.join("");

  useEffect(() => {
    if (step !== 2) return;
    setSecondsLeft(120);
    const interval = setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? (clearInterval(interval), 0) : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [step]);

  const formatTime = () => {
    const m = Math.floor(secondsLeft / 60);
    const s = secondsLeft % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  const handleOtpChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);
    if (value && index < 5) otpRefs.current[index + 1].focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  const handleOtpPaste = (e) => {
    const data = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!data) return;
    const newOtp = [...otpDigits];
    data.split("").forEach((d, i) => newOtp[i] = d);
    setOtpDigits(newOtp);
    const nextIndex = Math.min(data.length, 5);
    otpRefs.current[nextIndex].focus();
  };

  const sendOtp = async () => {
    try {
      if (!email) { toast.warning("Please enter your email"); return; }
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/devopstrio/auth/send-otp`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      toast.success("Verification code sent");
      setOtpDigits(Array(6).fill(""));
      setStep(2);
      setTimeout(() => otpRefs.current[0]?.focus(), 200);
    } catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  const resendOtp = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/devopstrio/auth/resend-otp`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      toast.success("New code sent");
      setOtpDigits(Array(6).fill(""));
      setSecondsLeft(120);
      setTimeout(() => otpRefs.current[0]?.focus(), 200);
    } catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  const verifyOtp = async () => {
    try {
      if (otp.length !== 6) { toast.warning("Enter 6-digit code"); return; }
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/devopstrio/auth/verify-otp`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      login(data.token, data.user);
      navigate("/devopstrio/dashboard");
    } catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  return (

    
    <div className="devopstrio-bg">
        <div className="premium-login-home-container">
        <Link to="/" className="premium-devlogin-home-btn">
          <FiHome size={20} />
          <span>Home</span>
        </Link>
      </div>
      <div className="devopstrio-card">
        <div className="devopstrio-logo">
          <img src="/Home/devlogo.png" alt="Devopstrio" />
        </div>
        <div className="devopstrio-title">Developer Portal</div>
        <div className="devopstrio-subtitle">
          Authenticate to access Devopstrio maintenance dashboard
        </div>

        <div className="devopstrio-form">
          {step === 1 && (
            <>
              <label className="form-label">EMAIL ADDRESS</label>
              <input className="devopstrio-input" type="email"
                placeholder="developer@company.com" value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyPress={e => e.key === 'Enter' && sendOtp()}
              />
              <button className="devopstrio-btn" disabled={loading} onClick={sendOtp}>
                {loading ? <span className="loading-dots"><span></span><span></span><span></span></span> : "Send Verification Code"}
              </button>
            </>
          )}

          {step === 2 && (
            <>
              <label className="form-label">VERIFICATION CODE</label>
              <div className="otp-instruction">Enter code sent to {email}</div>
              <div className="otp-container">
                <div className="otp-box-wrapper" onPaste={handleOtpPaste}>
                  {otpDigits.map((d, i) => (
                    <input key={i} ref={el => otpRefs.current[i] = el}
                      className="otp-box" maxLength="1" value={d}
                      onChange={e => handleOtpChange(i, e.target.value)}
                      onKeyDown={e => handleOtpKeyDown(i, e)}
                      inputMode="numeric" autoComplete="one-time-code"
                    />
                  ))}
                </div>
                <div className="otp-hint">Tip: You can paste the code directly</div>
              </div>

              <button className="devopstrio-btn" disabled={loading || secondsLeft === 0} onClick={verifyOtp}>
                {loading ? <span className="loading-dots"><span></span><span></span><span></span></span> : "Verify & Continue"}
              </button>

              <div className="devopstrio-timer-row">
                <div>Code expires in <span className="devopstrio-timer">{formatTime()}</span></div>
                <button className="devopstrio-resend" disabled={secondsLeft > 0 || loading} onClick={resendOtp}>
                  Resend Code
                </button>
              </div>

              <div className="devopstrio-back" onClick={() => setStep(1)}>← Use different email</div>
            </>
          )}
        </div>

        <div className="devopstrio-footer">
          <div>© {new Date().getFullYear()} Devopstrio</div>
          <div style={{ fontSize: '11px', marginTop: '4px', opacity: 0.7 }}>
            Secure authentication system v2.1 • Authorized access only
          </div>
        </div>
      </div>
    </div>
  );
}